module.exports = __webpack_public_path__ + "static/media/logo.002d9601.svg";